<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {};
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.axios.get('https://manage.uziliving.com/api/base/info').then(data => {
        console.log(data.data.data.contact);

        if (data && data.data && data.data.data && data.data.data.contact) {
          const company = data.data.data.contact;
          localStorage.setItem('company', JSON.stringify(company));
        }
      });
      const link = window.location.href.split('?')[0];
      if (link !== window.location.href) {
        window.location.href = link;
      } //为了兼容iOS系统，否则有可能地址取值出现错误
      const url = window.location.href.split('#')[0];
      const params = {
        url: url,
      };
      this.axios
        .get('https://api.uziliving.com/service/wechat/signpackage', { params })
        .then(res => {
          this.shareWx(res.data);
        });
    },
    shareWx(data) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.result.appId, // 必填，公众号的唯一标识
        timestamp: data.result.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.result.nonceStr, // 必填，生成签名的随机串
        signature: data.result.signature, // 必填，签名
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'], // 必填，需要使用的JS接口列表
      });
      wx.ready(function() {
        var config = {
          title: '游梓公寓 - 英国留学公寓一站式服务平台',
          desc: '你好，初次见面，我是Uziliving',
          link: location.href,
          imgUrl: 'https://cdn.hanlandglobal.com/h5-shear-banner.png',
          type: 'link',
          success: function() {},
          cancel: function() {},
        };
        wx.onMenuShareTimeline(config);
        wx.onMenuShareAppMessage(config);
        wx.updateAppMessageShareData(config);
      });
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html {
  font-size: 13.3vw;
}
</style>
